document.addEventListener('alpine:init', function () {
    Alpine.data('video', function () {
        var iframe;
        return {
            played: false,
            init: function () {
                iframe = this.$root.querySelector('iframe');
            },
            setPlayed: function () {
                this.played = true;
                this.autoplayIframe();
                this.$store.app.track({
                    event: 'video-play',
                    type: 'click',
                    module: 'video',
                    data: {},
                });
            },
            autoplayIframe: function () {
                var src = iframe.dataset.src || iframe.src;
                var connector = src.includes('?') ? '&' : '?';
                // Update the iframe src so that it can start autoplaying the video.
                iframe.src = "".concat(src).concat(connector, "autoplay=1");
            },
        };
    });
});
